// auth.context.ts
import { HttpContext, HttpContextToken, HttpHeaders } from '@angular/common/http';

export enum AuthMode {
  Public = 'public',
  Bearer = 'Bearer',
  ApiKey = 'apikey',
}

export const AUTH_MODE = new HttpContextToken<AuthMode>(() => AuthMode.Bearer);

// Helpers para uso cómodo
export const withPublic = (ctx = new HttpContext()) => ctx.set(AUTH_MODE, AuthMode.Public);
export const withBearer = (ctx = new HttpContext()) => ctx.set(AUTH_MODE, AuthMode.Bearer);
export const withApiKey = (ctx = new HttpContext()) => ctx.set(AUTH_MODE, AuthMode.ApiKey);

// Helper que añade directamente los headers requeridos junto al contexto Bearer.
// Se pasa el token desde donde tengas this.getToken() (por ejemplo en un servicio/componente):
// this.http.post(url, body, withBearerJson(this.getToken()))
export const withBearerJson = (token: string, ctx = new HttpContext()) => {
  return {
    context: withBearer(ctx),
    headers: new HttpHeaders({
      Authorization: "Bearer " + token,
      'Content-Type': 'application/json',
    }),
  };
};
